import { merge, omit } from 'lodash';

import { ICustomer } from 'shared/domain/entities';

const removeMaskPlaceholder = (value?: string) => value?.replace(/_/g, '');

export default function buildCustomerUpdateBody(
  customer: Partial<ICustomer>,
  values: Partial<ICustomer>,
): Partial<ICustomer> {
  const hasGuardian = Boolean(customer.guardian || values.guardian);

  const body = merge(
    {},
    { address: customer.address, guardian: customer.guardian },
    values,
    {
      document: removeMaskPlaceholder(values.document),
      ...(hasGuardian
        ? {
            guardian: {
              document: removeMaskPlaceholder(values.guardian?.document),
            },
          }
        : {}),
    },
  );

  return omit(body, [
    'alternativeDocument',
    'guardian.alternativeDocument',
  ]) as Partial<ICustomer>;
}
